import { SAvatar } from './styled';
import { AvatarProps } from './types';

export const Avatar = (props: AvatarProps) => {
  return <SAvatar {...props} />;
};
